import React from 'react';

import {Skeleton, StarRating} from '@optimaxdev/design-system';
import {Icon, TruckMini, CalendarMini, TrustPilot, MoneyBackMini} from '@optimaxdev/icons';
import classNames from 'classnames';

import {useTrustpilotData} from 'hooks/useTrustpilotData/useTrustpilotData';

import {TrustpilotExcellent} from './trustpilotExcellent/trustpilotExcellent';

import s from './trustpilotWrapper.scss';

const BENEFITS = [
    {
        className: s.truckIcon,
        icon: TruckMini,
        title: 'Free shipping & returns',
    },
    {
        icon: MoneyBackMini,
        title: 'Money-back guarantee',
    },
    {
        icon: CalendarMini,
        title: '365 day warranty',
    },
];

/**
 * Ctp Trustpilot wrapper
 */
export const TrustpilotWrapper = () => {
    const {isLoading, trustpilotRating} = useTrustpilotData();

    if (isLoading) {
        return (
            <div className={s.skeleton}>
                <Skeleton />
            </div>
        );
    }

    return (
        <div className={s.trustpilotWrapper}>
            {trustpilotRating?.score && trustpilotRating.score > 4 ? (
                <>
                    <ul className={s.benefits}>
                        {BENEFITS.map(benefit => (
                            <li className={s.benefitItem} key={benefit.title}>
                                <Icon
                                    className={classNames(s.icon, benefit.className)}
                                    icon={benefit.icon}
                                    strokeWidth={1.2}
                                />
                                <span className={s.benefitText}>{benefit.title}</span>
                            </li>
                        ))}
                    </ul>
                    <div className={s.wrapper}>
                        <StarRating
                            gap={2}
                            rating={trustpilotRating.score ? trustpilotRating.score * 20 : 90}
                            size={15}
                            type="trustpilot"
                        />
                        <Icon className={s.trustpilotIcon} icon={TrustPilot} />
                        <span className={s.reviewsCount}>
                            {trustpilotRating.numberOfReviews
                                ? `${trustpilotRating.numberOfReviews.toLocaleString('en-US')}+`
                                : '67,848+'}
                        </span>
                        <p className={s.rating}>{trustpilotRating.starsRepresentation}</p>
                    </div>
                </>
            ) : (
                <TrustpilotExcellent numberOfReviews={trustpilotRating?.numberOfReviews} />
            )}
        </div>
    );
};
